import { SWITCH_COMMITTEE } from '../store/actions.type';
import { getNotifications } from './notificationUtils';
import { GET_FORUM_THREADS } from "@/store/actions.type";

export default function switchCommittee(com){

  if(com.id !== this.$store.getters.getSelectedCommittee){
    this.$store.dispatch(SWITCH_COMMITTEE,com.id);
    let currentRoute = this.$router.currentRoute;
    if(currentRoute.name === 'discussion' || currentRoute.name === 'new-discussion' ||
        currentRoute.name === 'edit-discussion') {
      // If Committee is being switch on above selected routes; then
      // List of forums to be updated and user must be moved to /forum view.
      this.$store.state.forums.forums = [];
      this.$router.push({name: 'forum'});
      return true;
    }
    // IF A COMMITTE IS SWITCHED - need to update notification
    getNotifications();
  }
};

export function checkIfCommitteeAdmin() {
  let selectedCommittee = this.$store.getters.getSelectedCommittee;
  if (!selectedCommittee )
    return false;
  let userId = this.$store.state.auth.user.id;
  let com = this.$store.state.auth.user.committees.filter(ele => {
    return ele.id == selectedCommittee;
  })[0];
  return com.admin_id === this.$store.state.auth.user.id;
};
